import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { RefreshCw } from 'lucide-react';
import { useRegisterSW } from 'virtual:pwa-register/react';

import { AnalyticsEvents } from '@llura/constants';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@llura/ui';

import { trackEvent } from '../../lib/analytics';
import { useStrings } from '../../hooks/useStrings';

export function UpdateAvailableDialog() {
  const { strings } = useStrings();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  useEffect(() => {
    if (needRefresh) trackEvent(AnalyticsEvents.UpdatePrompted);
  }, [needRefresh]);

  const handleUpdate = () => {
    trackEvent(AnalyticsEvents.UpdateApplied);
    void updateServiceWorker(true);
  };

  const handleDismiss = () => {
    setNeedRefresh(false);
  };

  return (
    <Dialog open={needRefresh} onOpenChange={(open) => !open && handleDismiss()}>
      <DialogContent className="border-accent/50">
        <DialogHeader className="items-center text-center">
          <motion.div
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 220, damping: 14 }}
            className="mx-auto mb-2 flex h-16 w-16 items-center justify-center rounded-full bg-accent text-accent-foreground glow-accent"
          >
            <RefreshCw className="h-7 w-7" />
          </motion.div>
          <DialogTitle className="font-serif text-3xl">{strings.systemUpdate.title}</DialogTitle>
          <DialogDescription>{strings.systemUpdate.description}</DialogDescription>
        </DialogHeader>

        <DialogFooter className="sm:justify-center">
          <Button variant="ghost" onClick={handleDismiss}>
            {strings.systemUpdate.laterCta}
          </Button>
          <Button
            onClick={handleUpdate}
            className="bg-accent text-accent-foreground hover:bg-accent/90"
          >
            {strings.systemUpdate.updateCta}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
